import React, { ReactElement, useCallback } from 'react';
import isEqual from 'lodash.isequal';
import { useLoginAction } from 'b2b-apps/shop/context/hooks';
import { ROUTES } from 'b2b-apps/shop/routes/components/Router';
import { useRouterPush, useUrlCreator } from 'b2b-apps/shop/routes/hooks';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from './';

const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const push = useRouterPush();
    const urlCreator = useUrlCreator();
    const redirectToLogin = useLoginAction();

    const handleLoginClick = useCallback(
      (): void => {
        redirectToLogin();
      },
      [redirectToLogin],
    );

    const handleHomepageClick = useCallback(
      (): void => {
        push(urlCreator(ROUTES.homepage));
      },
      [push, urlCreator],
    );

    const injectedProps: InjectedProps = {
      onLoginClick: handleLoginClick,
      onHomepageClick: handleHomepageClick,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return React.memo(WithContainer, (prevProps, nextProps) => isEqual(prevProps, nextProps));
};

export { withContainer };
